module.exports = __webpack_public_path__ + "media/icons/checkbox_small-5fee1c4b.svg";